<template>
  <div></div>
</template>

<script>
import Store from '@/Store.js'
export default {
  async created () {
    let newQuery = { ...this.$route.query }
    let sid = newQuery.sid
    if (sid) {
      Store.set('sid', sid)
      delete newQuery.sid
    }
    let u = newQuery.nutsbptoken
    if (u) {
      Store.set('u', u)
      delete newQuery.nutsbptoken
    }
    // location.href = location.href.replace(`nutsbptoken=${u}`, '')
    this.$router.push({
      path: '/',
      query: newQuery
    })
  }
}
</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/page/WriteAndRedirectToHomePage.vue